import { render, staticRenderFns } from "./statisticalList.vue?vue&type=template&id=36aef0c0&scoped=true"
import script from "./statisticalList.vue?vue&type=script&lang=js"
export * from "./statisticalList.vue?vue&type=script&lang=js"
import style0 from "./statisticalList.vue?vue&type=style&index=0&id=36aef0c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aef0c0",
  null
  
)

export default component.exports